import type {MutationFunction} from '@apollo/react-common';
import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    setOffice365ConflictCalendarSyncIsEnabled as setOffice365ConflictCalendarSyncIsEnabledMutation,
    setOffice365ConflictCalendarSyncIsEnabledVariables as setOffice365ConflictCalendarSyncIsEnabledVariables,
} from 'nutshell-graphql-types';

import SET_OFFICE365_CONFLICT_CALENDAR_SYNC_IS_ENABLED from '../mutations/set-office365-conflict-calendar-sync-is-enabled.graphql';

export const useSetOffice365ConflictCalendarSyncIsEnabled = (): {
    setOffice365ConflictCalendarSyncIsEnabled: (isEnabled: boolean) => Promise<any>;
    enableO365ConflictCalendar: MutationFunction<
        setOffice365ConflictCalendarSyncIsEnabledMutation,
        setOffice365ConflictCalendarSyncIsEnabledVariables
    >;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setOffice365ConflictCalendarSyncIsEnabled, {loading, error}] = useMutation<
        setOffice365ConflictCalendarSyncIsEnabledMutation,
        setOffice365ConflictCalendarSyncIsEnabledVariables
    >(SET_OFFICE365_CONFLICT_CALENDAR_SYNC_IS_ENABLED);

    return {
        setOffice365ConflictCalendarSyncIsEnabled: (isEnabled: boolean) =>
            setOffice365ConflictCalendarSyncIsEnabled({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        enableO365ConflictCalendar: setOffice365ConflictCalendarSyncIsEnabled,
    };
};
